import React from 'react';
import styles from '../Assets/AppointmentBanner.module.css';
import bgImage from '../Assets/img/appointment-banner.jpg';
import AppointmentMobile from '../Assets/img/appointment-mobile.webp';
import { useTranslation } from 'react-i18next';
import LocalizedLink from '../../../../Components/LocalizedLink';

import { BsArrowRight } from "react-icons/bs";
import { SlDiamond } from "react-icons/sl";
import { IoChatbubbleOutline } from "react-icons/io5";
import { RiStore2Line } from "react-icons/ri";
import { isMobileOnly } from 'react-device-detect';
import { Container } from 'react-bootstrap';

const AppointmentBanner = () => {
    const { t } = useTranslation();

    return (
        <section
            className={styles.appointmentSection}
            style={{ backgroundImage: `url(${bgImage})` }}
        >
            <div className={styles.overlay} />
            <Container fluid className="home-showcase-container">
                <div className={styles.innerContainer}>
                    <div className={styles.contentCol}>

                        {/* Brand Header */}
                        <div className={styles.brandWrapper}>
                            <h4 className={styles.brandTitle}>MANUEL SPINOSA</h4>
                            <div className={styles.brandSubWrapper}>
                                <span className={styles.brandDash}>―</span>
                                <span className={styles.brandSub}>{t('appointmentBanner.brandSub')}</span>
                                <span className={styles.brandDash}>―</span>
                            </div>
                            <div className={styles.titleDivider} />
                        </div>

                        {isMobileOnly ? <img className='img-fluid mb-3' src={AppointmentMobile} /> : null}

                        {/* Heading */}
                        <h2 className={styles.mainHeading}>
                            <span>{t('appointmentBanner.titleLine1')}</span>
                            <span className={styles.headingBreak}>{t('appointmentBanner.titleLine2')}</span>
                        </h2>

                        {/* Subtitle / Description */}
                        <p className={styles.description}>
                            {t('appointmentBanner.description')}
                        </p>

                        {/* Features Strip */}
                        <div className={styles.featureGrid}>
                            <div className={styles.featureItem}>
                                <SlDiamond className={styles.featureIcon} />
                                <span className={styles.featureText}>
                                    {t('appointmentBanner.feature1')}
                                </span>
                            </div>
                            <div className={styles.featureDivider} />

                            <div className={styles.featureItem}>
                                <IoChatbubbleOutline className={styles.featureIcon} />
                                <span className={styles.featureText}>
                                    {t('appointmentBanner.feature2')}
                                </span>
                            </div>
                            <div className={styles.featureDivider} />

                            <div className={styles.featureItem}>
                                <RiStore2Line className={styles.featureIcon} />
                                <span className={styles.featureText}>
                                    {t('appointmentBanner.feature3')}
                                </span>
                            </div>
                        </div>

                        {/* Action Buttons */}
                        <div className={styles.buttonGroup}>
                            <LocalizedLink to="/make-an-appointment" className={styles.linkWrapper}>
                                <button type="button" className={`${styles.ctaBtn} ${styles.primaryBtn}`}>
                                    <span>{t('appointmentBanner.btnVirtual')}</span>
                                    <BsArrowRight className={styles.btnArrow} />
                                </button>
                            </LocalizedLink>

                            <LocalizedLink to="/make-an-appointment" className={styles.linkWrapper}>
                                <button type="button" className={`${styles.ctaBtn} ${styles.outlineBtn}`}>
                                    <span>{t('appointmentBanner.btnShowroom')}</span>
                                    <BsArrowRight className={styles.btnArrow} />
                                </button>
                            </LocalizedLink>
                        </div>

                    </div>
                </div>
            </Container>
        </section>
    );
};

export default AppointmentBanner;